var _path, _rect, _mask, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "350px",
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.686 186.11C287.398 203.122 276.926 236 276.926 236H117.65C117.65 236 113.917 235.743 111.524 233.981C108.943 232.082 107.904 227.925 107.904 227.925L102.335 169.384C102.335 169.384 100.978 160.157 103.727 158.137C105.678 156.703 110.131 157.272 110.131 157.272H174.176C174.176 157.272 176.406 157.233 177.518 158.137C178.36 158.822 178.91 161.597 178.91 161.597L187.82 227.925H199.794L191.44 170.826C191.44 170.826 245.358 162.745 269.686 186.11Z",
    fill: "url(#paint0_linear_53_2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 194.781,
    y: 97,
    width: 57.3615,
    height: 60.5602,
    rx: 28.6807,
    fill: "#374A74"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_53_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 167C66 97.9644 121.964 42 191 42C260.036 42 316 97.9644 316 167C316 236.036 260.036 292 191 292C121.964 292 66 236.036 66 167Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 162.5C57 90.9791 114.979 33 186.5 33H195.5C267.021 33 325 90.9791 325 162.5L307 167C307 102.935 255.065 51 191 51C126.935 51 75 102.935 75 167L57 162.5ZM75 167M316 292H66H316M186.5 292C114.979 292 57 234.021 57 162.5C57 90.9791 114.979 33 186.5 33L191 51C126.935 51 75 102.935 75 167C75 236.036 126.935 292 191 292H186.5ZM195.5 33C267.021 33 325 90.9791 325 162.5C325 234.021 267.021 292 195.5 292H191C255.065 292 307 236.036 307 167C307 102.935 255.065 51 191 51L195.5 33Z",
    fill: "url(#paint1_linear_53_2)",
    mask: "url(#path-4-inside-1_53_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.642 303.118L218.006 269.9L196 291.625L226.642 303.118Z",
    fill: "#497E93"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_2",
    x1: 191,
    y1: 157.16,
    x2: 255.089,
    y2: 237.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E8D9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_2",
    x1: 191,
    y1: 42,
    x2: 191,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E8D9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLogo);
export default __webpack_public_path__ + "static/media/light-logo.2f22cb4c09cac8691932e518a74b395f.svg";
export { ForwardRef as ReactComponent };